import { Link, useParams } from "react-router-dom";

export default function Footer() {
  const { lang = "en" } = useParams();
  return (
    <footer className="bg-ink text-white">
      <div className="container-page grid gap-8 py-12 md:grid-cols-[1.2fr_1fr_1fr_1fr]">
        <div>
          <img src="/logo.svg" className="h-10 rounded bg-white p-1" />
          <p className="mt-4 text-sm text-slate-300">Cross-border commerce foundation for products, manual payment, customer support, marketing, SEO and operational growth.</p>
          <form className="mt-5 flex gap-2"><input className="input text-ink" placeholder="Email" /><button className="btn-primary bg-coral">Subscribe</button></form>
        </div>
        <div><h3 className="font-bold">Shop</h3><Link className="mt-3 block text-slate-300" to={`/${lang}/products`}>Products</Link><Link className="mt-2 block text-slate-300" to={`/${lang}/compare`}>Compare</Link></div>
        <div><h3 className="font-bold">Support</h3><Link className="mt-3 block text-slate-300" to={`/${lang}/help`}>Help center</Link><Link className="mt-2 block text-slate-300" to={`/${lang}/contact`}>Contact</Link></div>
        <div><h3 className="font-bold">Policies</h3>{["privacy-policy","terms","refund-policy","shipping-policy"].map((p) => <Link key={p} className="mt-2 block text-slate-300" to={`/${lang}/${p}`}>{p.replaceAll("-", " ")}</Link>)}</div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-slate-400">© 2026 GlobalCart. Built for Cloudflare Pages.</div>
    </footer>
  );
}
